/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const AngleDoubleDownIconConfig = {
  name: 'AngleDoubleDownIcon',
  height: 512,
  width: 320,
  svgPath: 'M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(AngleDoubleDownIconConfig);
//# sourceMappingURL=angle-double-down-icon.js.map